import React from 'react';
import { motion } from 'framer-motion';
import { Globe2, TrendingUp, Home } from 'lucide-react';
export function FailedSolutions() {
  return <section className="py-12 md:py-20 px-4 md:px-6" style={{
    backgroundColor: 'var(--bg-deep)'
  }} data-id="element-137">
      <div className="max-w-[720px] mx-auto" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-139">
          <div className="text-center mb-10 md:mb-14" data-id="element-140">
            <h2 className="text-2xl md:text-4xl font-serif text-[var(--text-heading)] mb-4 leading-tight" data-id="element-141">
              La solución no es trabajar más duro en USA.{' '}
              <br className="hidden md:block" data-id="element-142" />
              <span className="text-[var(--accent)] italic" data-id="element-143">
                La solución es cambiar de sistema. 🌍
              </span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-10" data-id="element-144">
            {/* USA Card */}
            <div className="bg-[var(--bg-surface)] p-6 rounded-xl border border-[var(--border-subtle)] opacity-80" data-id="element-145">
              <div className="flex items-center gap-3 mb-4 text-[var(--text-muted)]" data-id="element-146">
                <TrendingUp className="w-5 h-5" data-id="element-147" />
                <h3 className="font-bold uppercase tracking-wider text-sm" data-id="element-148">
                  En USA
                </h3>
              </div>
              <p className="text-base md:text-lg text-[var(--text-muted)] leading-relaxed" data-id="element-149">
                Tus $10,000 o $20,000 ahorrados te hacen{' '}
                <strong className="text-[var(--text-primary)]" data-id="element-150">
                  "clase trabajadora"
                </strong>
                . El costo de vida devora tu capital mes a mes.
              </p>
            </div>

            {/* ESP/PAR Card */}
            <div className="bg-[var(--bg-card)] p-6 rounded-xl border border-[var(--accent)]/30 shadow-[0_8px_30px_rgba(212,136,58,0.15)] relative overflow-hidden" data-id="element-151">
              <div className="absolute top-0 left-0 w-1 h-full bg-[var(--accent)]" data-id="element-152"></div>
              <div className="flex items-center gap-3 mb-4 text-[var(--accent)]" data-id="element-153">
                <Home className="w-5 h-5" data-id="element-154" />
                <h3 className="font-bold uppercase tracking-wider text-sm" data-id="element-155">
                  España / Paraguay
                </h3>
              </div>
              <p className="text-base md:text-lg text-[var(--text-heading)] leading-relaxed" data-id="element-156">
                Esos mismos ahorros en destinos estratégicos te convierten en{' '}
                <strong data-id="element-157">PROPIETARIO</strong>.
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[var(--bg-elevated)] to-[var(--bg-surface)] p-6 md:p-8 rounded-2xl border border-[var(--accent)]/20 text-center" data-id="element-158">
            <Globe2 className="w-10 h-10 text-[var(--accent)] mx-auto mb-4 opacity-80" data-id="element-159" />
            <h3 className="text-xl md:text-2xl font-serif text-[var(--text-heading)] mb-3" data-id="element-160">
              El secreto es el "Arbitraje de Vida"
            </h3>
            <p className="text-lg text-[var(--text-primary)] font-light max-w-lg mx-auto" data-id="element-161">
              Gana o ahorra en dólares, vive con costos de moneda local fuerte.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}